var _path, _path2, _path3, _path4, _path5, _g, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNeffyInSchools(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 335,
    height: 64,
    viewBox: "0 0 335 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M157.163 50.3254L159.372 37.7484C159.521 36.946 160.049 36.4681 160.844 36.4681H162.14C162.935 36.4681 163.319 36.9425 163.17 37.7484L160.962 50.3254C160.844 51.1279 160.312 51.5744 159.517 51.5744H158.19C157.395 51.5744 157.042 51.1279 157.16 50.3254H157.163ZM159.873 32.0059C160.108 30.757 161.2 29.7766 162.673 29.7766C164.145 29.7766 164.913 30.757 164.677 32.0059C164.47 33.2549 163.323 34.2353 161.878 34.2353C160.433 34.2353 159.669 33.2549 159.873 32.0059Z",
    fill: "#304C9D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M165.088 50.3254L167.297 37.7484C167.446 36.946 167.975 36.468 168.77 36.468H170.066C170.861 36.468 171.244 36.9425 171.096 37.7484L170.861 39.1474C171.863 37.2425 173.806 36.1436 176.135 36.1436C179.789 36.1436 181.233 38.8194 180.525 42.9536L179.229 50.3289C179.111 51.1313 178.551 51.5779 177.756 51.5779H176.46C175.665 51.5779 175.313 51.1313 175.43 50.3289L176.699 43.1316C177.141 40.5429 176.256 39.3567 174.694 39.3567C173.132 39.3567 170.629 40.515 169.979 44.2026L168.891 50.3289C168.773 51.1313 168.213 51.5779 167.418 51.5779H166.122C165.327 51.5779 164.974 51.1313 165.092 50.3289L165.088 50.3254Z",
    fill: "#304C9D"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_166_1249",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 6,
    width: 55,
    height: 57
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0272 6.97058H0V62.1768H54.0272V6.97058Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_166_1249)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_166_1249",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 6,
    width: 56,
    height: 57
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.80231 36.3669C10.2551 37.0158 11.0051 37.431 11.8934 37.431C12.9442 37.431 13.9189 36.8519 14.4961 35.9936C14.8798 36.6984 15.6195 37.1589 16.5147 37.1589C17.6657 37.1589 18.7164 36.3948 19.1519 35.3412C19.3731 36.2343 20.1474 36.8763 21.1428 36.8763C22.4009 36.8763 23.5312 35.8436 23.6625 34.5737C23.7939 33.3003 22.8814 32.2711 21.6198 32.2711C20.6243 32.2711 19.7188 32.913 19.3109 33.8062C19.0966 32.7526 18.2049 31.9885 17.0539 31.9885C16.1587 31.9885 15.3222 32.4525 14.7899 33.1538C14.3924 32.2955 13.5352 31.7164 12.4845 31.7164C11.5962 31.7164 10.7563 32.1316 10.1721 32.7805C9.70553 32.0408 8.88636 31.5629 7.90474 31.5629C6.97842 31.5629 6.10741 31.9885 5.49217 32.6549C5.01518 31.9885 4.23058 31.5629 3.30771 31.5629C1.65901 31.5629 0.183118 32.9095 0.0102974 34.5737C-0.162523 36.2378 1.02994 37.5845 2.67865 37.5845C3.60151 37.5845 4.47253 37.1589 5.09122 36.4925C5.56821 37.1589 6.34936 37.5845 7.27568 37.5845C8.2573 37.5845 9.1767 37.1065 9.7954 36.3669M10.7321 31.7408C12.1665 31.7408 13.4557 30.5651 13.6044 29.1173C13.7564 27.6694 12.7126 26.4902 11.2782 26.4902C9.84379 26.4902 8.55455 27.6659 8.40592 29.1173C8.25384 30.5651 9.29768 31.7408 10.7321 31.7408ZM15.9305 31.3431C17.2613 31.3431 18.4537 30.2546 18.592 28.9114C18.7302 27.5683 17.7659 26.4798 16.4352 26.4798C15.1045 26.4798 13.912 27.5683 13.7737 28.9114C13.6355 30.2546 14.5998 31.3431 15.9305 31.3431ZM18.8028 25.6599C19.895 25.6599 20.8697 24.7668 20.9873 23.6643C21.1013 22.5619 20.3098 21.6722 19.2176 21.6722C18.1254 21.6722 17.1472 22.5654 17.0331 23.6643C16.9191 24.7668 17.7106 25.6599 18.8028 25.6599ZM18.9134 28.8382C18.789 30.0453 19.6565 31.0256 20.8525 31.0256C22.0484 31.0256 23.1199 30.0488 23.2478 28.8382C23.3722 27.6276 22.5046 26.6507 21.3087 26.6507C20.1128 26.6507 19.0413 27.6276 18.9134 28.8382ZM27.9692 34.5737C28.0833 33.4643 27.2883 32.5676 26.1892 32.5676C25.09 32.5676 24.1084 33.4678 23.9909 34.5737C23.8768 35.6831 24.6718 36.5797 25.7709 36.5797C26.8701 36.5797 27.8517 35.6831 27.9692 34.5737ZM24.1188 25.161C25.0831 25.161 25.9472 24.3725 26.0475 23.3992C26.1477 22.4258 25.4495 21.6374 24.4852 21.6374C23.5208 21.6374 22.6567 22.4258 22.5565 23.3992C22.4562 24.3725 23.1544 25.161 24.1188 25.161ZM27.7584 28.8033C27.869 27.7462 27.1086 26.8879 26.0578 26.8879C25.0071 26.8879 24.0704 27.7462 23.9598 28.8033C23.8492 29.8604 24.6096 30.7186 25.6603 30.7186C26.7111 30.7186 27.6478 29.8604 27.7584 28.8033ZM32.2724 34.5737C32.3692 33.6282 31.6918 32.8642 30.7551 32.8642C29.8184 32.8642 28.9785 33.6317 28.8817 34.5737C28.7815 35.5191 29.4624 36.2832 30.3991 36.2832C31.3358 36.2832 32.1722 35.5157 32.2724 34.5737ZM26.8493 19.7918C27.7134 19.7918 28.4911 19.0836 28.581 18.2079C28.6709 17.3357 28.0418 16.6275 27.1777 16.6275C26.3136 16.6275 25.5359 17.3357 25.446 18.2079C25.3562 19.0836 25.9852 19.7918 26.8493 19.7918ZM29.2135 24.7703C30.0431 24.7703 30.7896 24.09 30.8761 23.2526C30.9625 22.4153 30.3611 21.735 29.5281 21.735C28.6951 21.735 27.9519 22.4153 27.8655 23.2526C27.7791 24.09 28.3805 24.7703 29.2101 24.7703M30.406 30.4186C31.3012 30.4186 32.0996 29.6859 32.193 28.7858C32.2863 27.8822 31.6365 27.1531 30.7447 27.1531C29.853 27.1531 29.0511 27.8857 28.9578 28.7858C28.8644 29.6894 29.5108 30.4186 30.406 30.4186ZM33.7587 34.5737C33.6758 35.3622 34.2426 36.0006 35.0272 36.0006C35.8118 36.0006 36.5066 35.3622 36.5895 34.5737C36.6725 33.7852 36.1056 33.1468 35.3245 33.1468C34.5433 33.1468 33.8417 33.7852 33.7587 34.5737ZM32.2137 19.265C32.9534 19.265 33.6135 18.6614 33.693 17.9148C33.7691 17.1682 33.2333 16.5647 32.4937 16.5647C31.754 16.5647 31.0938 17.1682 31.0143 17.9148C30.9383 18.6614 31.474 19.265 32.2137 19.265ZM33.0743 23.1619C33.0018 23.8492 33.4995 24.4074 34.1804 24.4074C34.8613 24.4074 35.4765 23.8492 35.5457 23.1619C35.6183 22.4712 35.124 21.913 34.4396 21.913C33.7552 21.913 33.1435 22.4712 33.0743 23.1619ZM35.4005 27.4113C34.6539 27.4113 33.9868 28.0218 33.9073 28.7754C33.8278 29.5289 34.3705 30.1395 35.1171 30.1395C35.8637 30.1395 36.5308 29.5289 36.6102 28.7754C36.6897 28.0218 36.1471 27.4113 35.4005 27.4113ZM38.6495 34.5737C38.5839 35.1982 39.0332 35.7041 39.6519 35.7041C40.2706 35.7041 40.8271 35.1982 40.8927 34.5737C40.9584 33.9492 40.5091 33.4433 39.8869 33.4433C39.2648 33.4433 38.7117 33.9492 38.6461 34.5737M34.9235 13.683C35.4316 13.683 35.8844 13.2678 35.9362 12.755C35.9881 12.2421 35.6217 11.8269 35.1136 11.8269C34.6055 11.8269 34.1527 12.2421 34.1009 12.755C34.049 13.2678 34.4154 13.683 34.9235 13.683ZM37.6057 16.8717C37.1425 16.8717 36.7243 17.252 36.6759 17.723C36.6275 18.1905 36.9663 18.5707 37.4294 18.5707C37.8926 18.5707 38.3108 18.1905 38.3592 17.723C38.4076 17.252 38.0723 16.8717 37.6057 16.8717ZM39.0643 24.083C39.6 24.083 40.077 23.6434 40.1358 23.1061C40.1911 22.5654 39.804 22.1293 39.2682 22.1293C38.7325 22.1293 38.2555 22.5654 38.1967 23.1061C38.1414 23.6469 38.5286 24.083 39.0643 24.083ZM38.8638 28.7649C38.8016 29.3545 39.2267 29.8325 39.8109 29.8325C40.395 29.8325 40.9204 29.3545 40.9792 28.7649C41.0414 28.1753 40.6162 27.6973 40.0321 27.6973C39.448 27.6973 38.926 28.1753 38.8638 28.7649ZM44.4528 33.7503C44.0035 33.7503 43.5991 34.1202 43.5507 34.5737C43.5023 35.0272 43.8307 35.397 44.28 35.397C44.7294 35.397 45.1338 35.0272 45.1822 34.5737C45.2305 34.1202 44.9022 33.7503 44.4528 33.7503ZM40.3121 13.1422C40.6923 13.1422 41.0345 12.8317 41.0725 12.4479C41.114 12.0642 40.8374 11.7537 40.4572 11.7537C40.077 11.7537 39.7348 12.0642 39.6968 12.4479C39.6588 12.8317 39.9319 13.1422 40.3121 13.1422ZM42.6175 17.0112C42.2995 17.0112 42.0161 17.2694 41.985 17.5904C41.9504 17.9079 42.182 18.1695 42.5 18.1695C42.818 18.1695 43.1014 17.9079 43.1325 17.5904C43.1671 17.2694 42.9355 17.0112 42.6209 17.0112M43.8895 23.7585C44.2697 23.7585 44.6084 23.448 44.6499 23.0643C44.6879 22.6805 44.4148 22.37 44.0346 22.37C43.6544 22.37 43.3122 22.6805 43.2742 23.0643C43.2327 23.448 43.5092 23.7585 43.8895 23.7585ZM43.803 28.7614C43.7581 29.187 44.0657 29.5359 44.4874 29.5359C44.9091 29.5359 45.2893 29.1905 45.3308 28.7614C45.3757 28.3358 45.0681 27.9904 44.6464 27.9904C44.2247 27.9904 43.848 28.3358 43.803 28.7614ZM49.0153 34.0434C48.725 34.0434 48.4692 34.2806 48.4381 34.5702C48.407 34.8598 48.6178 35.097 48.9047 35.097C49.1916 35.097 49.4508 34.8598 49.4819 34.5702C49.513 34.2806 49.3022 34.0434 49.0153 34.0434ZM42.9908 7.61251C43.1601 7.61251 43.3122 7.47645 43.3295 7.3055C43.3468 7.13455 43.2258 6.995 43.0565 6.995C42.8871 6.995 42.7385 7.13455 42.7177 7.3055C42.7004 7.47645 42.8214 7.61251 42.9908 7.61251ZM45.5589 12.6573C45.7974 12.6573 46.0117 12.4619 46.0359 12.2212C46.0601 11.9804 45.8873 11.7851 45.6488 11.7851C45.4103 11.7851 45.196 11.9804 45.1683 12.2212C45.1441 12.4619 45.317 12.6573 45.5554 12.6573M47.5463 17.1857C47.377 17.1857 47.2249 17.3217 47.2076 17.4927C47.1903 17.6636 47.3113 17.8032 47.4807 17.8032C47.65 17.8032 47.8021 17.6636 47.8194 17.4927C47.8367 17.3217 47.7157 17.1857 47.5463 17.1857ZM48.763 22.6212C48.5383 22.6212 48.3344 22.8061 48.3137 23.0329C48.2895 23.2596 48.4519 23.4445 48.68 23.4445C48.9082 23.4445 49.1052 23.2596 49.1294 23.0329C49.1536 22.8061 48.9911 22.6212 48.763 22.6212ZM49.1536 29.2463C49.4232 29.2463 49.6617 29.0266 49.6893 28.7579C49.717 28.4858 49.5234 28.2695 49.2573 28.2695C48.9911 28.2695 48.7492 28.4893 48.7215 28.7579C48.6939 29.0266 48.8874 29.2463 49.1536 29.2463ZM53.5812 34.3399C53.4533 34.3399 53.3393 34.4446 53.3289 34.5737C53.3151 34.7028 53.4084 34.8074 53.5328 34.8074C53.6573 34.8074 53.7713 34.7028 53.7852 34.5737C53.799 34.4446 53.7057 34.3399 53.5812 34.3399ZM48.4174 6.98105L48.407 6.97058L48.3932 6.98105L48.4035 6.995L48.4174 6.98105ZM50.6986 12.2212C50.7885 12.2212 50.8714 12.1479 50.8818 12.0537C50.8921 11.9595 50.823 11.8863 50.7331 11.8863C50.6433 11.8863 50.5603 11.9595 50.55 12.0537C50.5396 12.1444 50.6087 12.2212 50.6986 12.2212ZM52.3784 17.4229L52.4026 17.4473L52.4302 17.4229L52.4061 17.3985L52.3784 17.4229ZM53.4603 22.8968C53.398 22.8968 53.3393 22.9491 53.3324 23.0119C53.3255 23.0747 53.3704 23.1271 53.4361 23.1271C53.5017 23.1271 53.557 23.0747 53.5639 23.0119C53.5709 22.9491 53.5259 22.8968 53.4603 22.8968ZM53.8128 28.9463C53.92 28.9463 54.0133 28.8591 54.0237 28.7544C54.034 28.6498 53.958 28.5626 53.8508 28.5626C53.7437 28.5626 53.6504 28.6498 53.64 28.7544C53.6296 28.8626 53.7057 28.9463 53.8094 28.9463M10.141 37.4031C8.70663 37.4031 7.41739 38.5788 7.26876 40.0301C7.11668 41.478 8.16052 42.6537 9.59493 42.6537C11.0293 42.6537 12.3186 41.478 12.4672 40.0301C12.6193 38.5788 11.5755 37.4031 10.141 37.4031ZM17.4168 40.2325C17.555 38.8893 16.5907 37.8008 15.26 37.8008C13.9293 37.8008 12.7368 38.8893 12.5985 40.2325C12.4603 41.5756 13.4246 42.6641 14.7554 42.6641C16.0861 42.6641 17.2785 41.5756 17.4168 40.2325ZM16.9433 43.4875C15.851 43.4875 14.8729 44.3806 14.7588 45.4831C14.6447 46.5855 15.4363 47.4786 16.5285 47.4786C17.6207 47.4786 18.5954 46.5855 18.7129 45.4831C18.827 44.3806 18.0355 43.4875 16.9433 43.4875ZM22.0553 40.3057C22.1797 39.0986 21.3122 38.1183 20.1162 38.1183C18.9203 38.1183 17.8488 39.0986 17.721 40.3057C17.5965 41.5128 18.4641 42.4932 19.66 42.4932C20.8559 42.4932 21.9309 41.5163 22.0553 40.3057ZM23.7213 45.7482C23.8215 44.7748 23.1233 43.9864 22.159 43.9864C21.1946 43.9864 20.3305 44.7748 20.2303 45.7482C20.1301 46.7216 20.8283 47.51 21.7926 47.51C22.7569 47.51 23.621 46.7216 23.7213 45.7482ZM24.4575 42.2594C25.5048 42.2594 26.4449 41.4012 26.5555 40.3406C26.6661 39.2835 25.9057 38.4253 24.855 38.4253C23.8042 38.4253 22.8675 39.2835 22.7569 40.3406C22.6463 41.4012 23.4068 42.2594 24.4575 42.2594ZM23.7697 49.3521C22.9056 49.3521 22.1279 50.0603 22.038 50.9325C21.9481 51.8082 22.5738 52.5129 23.4413 52.5129C24.3089 52.5129 25.0831 51.8047 25.173 50.9325C25.2628 50.0568 24.6372 49.3521 23.7697 49.3521ZM27.1708 44.3771C26.3412 44.3771 25.5947 45.0574 25.5082 45.8947C25.4218 46.732 26.0233 47.4123 26.8528 47.4123C27.6823 47.4123 28.4289 46.732 28.5153 45.8947C28.6017 45.0574 28.0003 44.3771 27.1708 44.3771ZM29.2032 41.9943C30.0984 41.9943 30.8968 41.2617 30.9901 40.3581C31.0834 39.4545 30.4371 38.7253 29.5419 38.7253C28.6467 38.7253 27.8482 39.458 27.7515 40.3581C27.6581 41.2617 28.3045 41.9943 29.1997 41.9943M29.0234 49.8789C28.2838 49.8789 27.6236 50.4825 27.5441 51.2291C27.4646 51.9757 28.0038 52.5792 28.74 52.5792C29.4762 52.5792 30.1398 51.9757 30.2193 51.2291C30.2954 50.4825 29.7596 49.8789 29.02 49.8789M32.0616 44.7365C31.3772 44.7365 30.7689 45.2947 30.6963 45.9854C30.6237 46.6762 31.1215 47.2344 31.8024 47.2344C32.4833 47.2344 33.0951 46.6762 33.1677 45.9854C33.2402 45.2947 32.7425 44.7365 32.0616 44.7365ZM35.404 40.372C35.4835 39.6185 34.9408 39.0079 34.1942 39.0079C33.4476 39.0079 32.7805 39.6185 32.701 40.372C32.6215 41.1256 33.1642 41.7361 33.9108 41.7361C34.6574 41.7361 35.3245 41.1256 35.404 40.372ZM30.5719 55.4609C30.0638 55.4609 29.611 55.8761 29.5592 56.3889C29.5073 56.9018 29.8737 57.3135 30.3783 57.3135C30.883 57.3135 31.3392 56.8983 31.3911 56.3889C31.4429 55.8761 31.0765 55.4609 30.5684 55.4609M34.0974 50.5732C33.6308 50.5732 33.216 50.9534 33.1677 51.4244C33.1193 51.8919 33.458 52.2722 33.9212 52.2722C34.3843 52.2722 34.8025 51.8919 34.8509 51.4244C34.8993 50.9534 34.5641 50.5732 34.0974 50.5732ZM36.8764 45.0644C36.3406 45.0644 35.8602 45.5005 35.8049 46.0413C35.7496 46.582 36.1367 47.0181 36.6725 47.0181C37.2082 47.0181 37.6852 46.582 37.7439 46.0413C37.7993 45.5005 37.4121 45.0644 36.8764 45.0644ZM39.7694 40.379C39.8316 39.7894 39.4065 39.3114 38.8223 39.3114C38.2382 39.3114 37.7163 39.7894 37.6541 40.379C37.5919 40.9686 38.017 41.4466 38.6011 41.4466C39.1853 41.4466 39.7072 40.9686 39.7694 40.379ZM35.8498 56.0052C35.4696 56.0052 35.1309 56.3157 35.0894 56.6994C35.0514 57.0832 35.3245 57.3937 35.7047 57.3937C36.0849 57.3937 36.4236 57.0832 36.4651 56.6994C36.5031 56.3157 36.23 56.0052 35.8498 56.0052ZM39.0816 50.9779C38.7636 50.9779 38.4802 51.236 38.4491 51.557C38.4145 51.8745 38.6461 52.1361 38.9641 52.1361C39.2821 52.1361 39.5655 51.878 39.5966 51.557C39.6277 51.236 39.3996 50.9779 39.085 50.9779M42.2546 46.0796C42.2926 45.6959 42.0195 45.3854 41.6393 45.3854C41.2591 45.3854 40.9169 45.6959 40.8789 46.0796C40.8374 46.4634 41.1139 46.7739 41.4942 46.7739C41.8744 46.7739 42.2131 46.4634 42.2546 46.0796ZM43.4367 39.6115C43.015 39.6115 42.6348 39.9569 42.5933 40.3825C42.5484 40.8081 42.856 41.1535 43.2777 41.1535C43.6993 41.1535 44.0761 40.8081 44.121 40.3825C44.166 39.9569 43.8583 39.6115 43.4367 39.6115ZM37.3776 61.5314C37.2082 61.5314 37.0561 61.6709 37.0388 61.8419C37.0216 62.0128 37.1425 62.1489 37.3119 62.1489C37.4813 62.1489 37.6333 62.0093 37.6506 61.8419C37.6679 61.6709 37.5469 61.5314 37.3776 61.5314ZM40.9964 56.4831C40.7579 56.4831 40.5436 56.6785 40.516 56.9192C40.4918 57.16 40.6646 57.3553 40.9031 57.3553C41.1416 57.3553 41.3559 57.16 41.3836 56.9192C41.4077 56.6785 41.2349 56.4831 40.9964 56.4831ZM43.9897 51.3407C43.8203 51.3407 43.6682 51.4768 43.651 51.6477C43.6337 51.8187 43.7581 51.9547 43.924 51.9547C44.0899 51.9547 44.2455 51.8187 44.2627 51.6477C44.28 51.4768 44.159 51.3407 43.9897 51.3407ZM46.3608 45.6994C46.1361 45.6994 45.9356 45.8843 45.9115 46.111C45.8873 46.3378 46.0497 46.5227 46.2778 46.5227C46.506 46.5227 46.7064 46.3378 46.7272 46.111C46.7514 45.8843 46.5889 45.6994 46.3608 45.6994ZM48.0441 39.8975C47.7779 39.8975 47.536 40.1139 47.5083 40.386C47.4807 40.6546 47.6742 40.8744 47.9438 40.8744C48.2134 40.8744 48.4519 40.6546 48.4796 40.386C48.5072 40.1139 48.3137 39.8975 48.0475 39.8975M42.6451 62.1628L42.6555 62.1768L42.6693 62.1628L42.659 62.1524L42.6451 62.1628ZM46.0428 56.9227C45.9495 56.9227 45.87 56.996 45.8596 57.0902C45.8492 57.1844 45.9149 57.2576 46.0082 57.2576C46.1016 57.2576 46.1811 57.1809 46.1914 57.0902C46.2018 56.9995 46.1327 56.9227 46.0428 56.9227ZM48.8079 51.721L48.8321 51.7454L48.8598 51.721L48.8356 51.6931L48.8079 51.721ZM51.0511 46.0168C50.9889 46.0168 50.9302 46.0692 50.9233 46.132C50.9163 46.1948 50.9613 46.2471 51.0269 46.2471C51.0926 46.2471 51.1479 46.1948 51.1548 46.132C51.1617 46.0692 51.1168 46.0168 51.0511 46.0168ZM52.6411 40.1976C52.5374 40.1976 52.4406 40.2848 52.4302 40.3895C52.4199 40.4976 52.4959 40.5813 52.5996 40.5813C52.7033 40.5813 52.8001 40.4976 52.8105 40.3895C52.8208 40.2813 52.7448 40.1976 52.6376 40.1976",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_166_1249)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_166_1249",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 6,
    width: 56,
    height: 57
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0285 6.38537L-0.745605 6.974L-0.157168 62.7597L54.6169 62.1711L54.0285 6.38537Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_166_1249)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.598 62.7627L47 6.38428H54.6248V62.7627H47.598Z",
    fill: "#AAD2A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.221 62.7627L46.6196 6.38428H46.9998L47.5978 62.7627H47.221Z",
    fill: "#AAD2A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.8411 62.7627L46.2432 6.38428H46.6199L47.2213 62.7627H46.8411Z",
    fill: "#AAD2A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4642 62.7627L45.8628 6.38428H46.243L46.841 62.7627H46.4642Z",
    fill: "#A9D2A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0838 62.7627L45.4858 6.38428H45.8626L46.464 62.7627H46.0838Z",
    fill: "#A6D1AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7074 62.7627L45.106 6.38428H45.4862L46.0841 62.7627H45.7074Z",
    fill: "#A6D1AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.327 62.7627L44.729 6.38428H45.1058L45.7072 62.7627H45.327Z",
    fill: "#A5D0AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9466 62.7627L44.3486 6.38428H44.7288L45.3268 62.7627H44.9466Z",
    fill: "#A3CFAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5701 62.7627L43.9722 6.38428H44.3489L44.9469 62.7627H44.5701Z",
    fill: "#A3CFAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1898 62.7627L43.5918 6.38428H43.972L44.57 62.7627H44.1898Z",
    fill: "#A0CEAD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8133 62.7627L43.2119 6.38428H43.5921L44.1901 62.7627H43.8133Z",
    fill: "#A0CEAD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4329 62.7627L42.835 6.38428H43.2117L43.8131 62.7627H43.4329Z",
    fill: "#A0CEAD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.056 62.7627L42.4546 6.38428H42.8348L43.4328 62.7627H43.056Z",
    fill: "#9ECDAE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6761 62.7627L42.0781 6.38428H42.4549L43.0563 62.7627H42.6761Z",
    fill: "#9ECDAE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2992 62.7627L41.6978 6.38428H42.078L42.6759 62.7627H42.2992Z",
    fill: "#9DCCAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9188 62.7627L41.3208 6.38428H41.6976L42.299 62.7627H41.9188Z",
    fill: "#9CCCAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5423 62.7627L40.9409 6.38428H41.3211L41.9191 62.7627H41.5423Z",
    fill: "#9ACBB0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1619 62.7627L40.564 6.38428H40.9407L41.5421 62.7627H41.1619Z",
    fill: "#98CBB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.782 62.7627L40.1841 6.38428H40.5643L41.1622 62.7627H40.782Z",
    fill: "#98CBB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4051 62.7627L39.8071 6.38428H40.1839L40.7818 62.7627H40.4051Z",
    fill: "#97CAB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0247 62.7627L39.4268 6.38428H39.807L40.4049 62.7627H40.0247Z",
    fill: "#95C9B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6483 62.7627L39.0469 6.38428H39.4271L40.025 62.7627H39.6483Z",
    fill: "#95C9B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2679 62.7627L38.6699 6.38428H39.0467L39.6481 62.7627H39.2679Z",
    fill: "#94C9B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.891 62.7627L38.2896 6.38428H38.6698L39.2677 62.7627H38.891Z",
    fill: "#93C8B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.511 62.7627L37.9131 6.38428H38.2898L38.8913 62.7627H38.511Z",
    fill: "#92C8B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1341 62.7627L37.5327 6.38428H37.9129L38.5109 62.7627H38.1341Z",
    fill: "#91C7B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7542 62.7627L37.1562 6.38428H37.533L38.1344 62.7627H37.7542Z",
    fill: "#8FC7B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3773 62.7627L36.7759 6.38428H37.1561L37.754 62.7627H37.3773Z",
    fill: "#8DC6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9969 62.7627L36.3989 6.38428H36.7757L37.3771 62.7627H36.9969Z",
    fill: "#8DC6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.617 62.7627L36.019 6.38428H36.3992L36.9972 62.7627H36.617Z",
    fill: "#8AC5B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2401 62.7627L35.6421 6.38428H36.0188L36.6168 62.7627H36.2401Z",
    fill: "#8AC5B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8597 62.7627L35.2617 6.38428H35.6419L36.2399 62.7627H35.8597Z",
    fill: "#8AC5B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4833 62.7627L34.8818 6.38428H35.262L35.86 62.7627H35.4833Z",
    fill: "#88C4B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1028 62.7627L34.5049 6.38428H34.8816L35.483 62.7627H35.1028Z",
    fill: "#88C4B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7264 62.7627L34.125 6.38428H34.5052L35.1032 62.7627H34.7264Z",
    fill: "#86C4B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.346 62.7627L33.748 6.38428H34.1248L34.7262 62.7627H34.346Z",
    fill: "#84C3BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9691 62.7627L33.3677 6.38428H33.7479L34.3458 62.7627H33.9691Z",
    fill: "#84C3BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5892 62.7627L32.9912 6.38428H33.368L33.9694 62.7627H33.5892Z",
    fill: "#83C2BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2088 62.7627L32.6108 6.38428H32.991L33.589 62.7627H33.2088Z",
    fill: "#82C2BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8323 62.7627L32.2344 6.38428H32.6111L33.2091 62.7627H32.8323Z",
    fill: "#80C2BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.452 62.7627L31.854 6.38428H32.2342L32.8322 62.7627H32.452Z",
    fill: "#7EC1BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.075 62.7627L31.4771 6.38428H31.8538L32.4518 62.7627H32.075Z",
    fill: "#7EC1BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6951 62.7627L31.0972 6.38428H31.4774L32.0753 62.7627H31.6951Z",
    fill: "#7DC0BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3182 62.7627L30.7168 6.38428H31.097L31.695 62.7627H31.3182Z",
    fill: "#7CC0BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9378 62.7627L30.3398 6.38428H30.7166L31.318 62.7627H30.9378Z",
    fill: "#79BFBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5614 62.7627L29.96 6.38428H30.3402L30.9381 62.7627H30.5614Z",
    fill: "#79BFBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.181 62.7627L29.583 6.38428H29.9598L30.5612 62.7627H30.181Z",
    fill: "#78BFBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8041 62.7627L29.2026 6.38428H29.5828L30.1808 62.7627H29.8041Z",
    fill: "#76BEBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4241 62.7627L28.8262 6.38428H29.2029L29.8043 62.7627H29.4241Z",
    fill: "#76BEBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0438 62.7627L28.4458 6.38428H28.826L29.424 62.7627H29.0438Z",
    fill: "#72BDC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6673 62.7627L28.0693 6.38428H28.4461L29.044 62.7627H28.6673Z",
    fill: "#72BDC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2869 62.7627L27.689 6.38428H28.0692L28.6671 62.7627H28.2869Z",
    fill: "#72BDC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.91 62.7627L27.312 6.38428H27.6888L28.2867 62.7627H27.91Z",
    fill: "#71BCC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5301 62.7627L26.9321 6.38428H27.3123L27.9103 62.7627H27.5301Z",
    fill: "#6FBCC2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1532 62.7627L26.5518 6.38428H26.932L27.5299 62.7627H27.1532Z",
    fill: "#6EBCC2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7733 62.7627L26.1753 6.38428H26.552L27.1535 62.7627H26.7733Z",
    fill: "#6CBBC3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3963 62.7627L25.7949 6.38428H26.1751L26.7731 62.7627H26.3963Z",
    fill: "#6CBBC3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0159 62.7627L25.418 6.38428H25.7947L26.3961 62.7627H26.0159Z",
    fill: "#6ABAC3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.639 62.7627L25.0376 6.38428H25.4178L26.0158 62.7627H25.639Z",
    fill: "#69BAC4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2591 62.7627L24.6611 6.38428H25.0379L25.6393 62.7627H25.2591Z",
    fill: "#66B9C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8787 62.7627L24.2808 6.38428H24.661L25.2589 62.7627H24.8787Z",
    fill: "#66B9C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5023 62.7627L23.9043 6.38428H24.281L24.879 62.7627H24.5023Z",
    fill: "#65B9C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1219 62.7627L23.5239 6.38428H23.9041L24.5021 62.7627H24.1219Z",
    fill: "#64B8C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7454 62.7627L23.1475 6.38428H23.5242L24.1222 62.7627H23.7454Z",
    fill: "#62B8C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3651 62.7627L22.7671 6.38428H23.1473L23.7453 62.7627H23.3651Z",
    fill: "#5FB7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9881 62.7627L22.3867 6.38428H22.7669L23.3649 62.7627H22.9881Z",
    fill: "#5FB7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6077 62.7627L22.0098 6.38428H22.3865L22.9879 62.7627H22.6077Z",
    fill: "#5EB7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2313 62.7627L21.6299 6.38428H22.0101L22.608 62.7627H22.2313Z",
    fill: "#5BB6C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8509 62.7627L21.2529 6.38428H21.6297L22.2311 62.7627H21.8509Z",
    fill: "#5BB6C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4745 62.7627L20.873 6.38428H21.2533L21.8512 62.7627H21.4745Z",
    fill: "#58B5C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0941 62.7627L20.4961 6.38428H20.8728L21.4743 62.7627H21.0941Z",
    fill: "#58B5C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7137 62.7627L20.1157 6.38428H20.4959L21.0939 62.7627H20.7137Z",
    fill: "#56B5C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3372 62.7627L19.7393 6.38428H20.116L20.714 62.7627H20.3372Z",
    fill: "#53B4CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9568 62.7627L19.3589 6.38428H19.7391L20.3371 62.7627H19.9568Z",
    fill: "#53B4CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5799 62.7627L18.9785 6.38428H19.3587L19.9567 62.7627H19.5799Z",
    fill: "#52B4CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2 62.7627L18.6021 6.38428H18.9788L19.5802 62.7627H19.2Z",
    fill: "#4EB3CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8231 62.7627L18.2217 6.38428H18.6019L19.1998 62.7627H18.8231Z",
    fill: "#4EB3CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4432 62.7627L17.8452 6.38428H18.222L18.8234 62.7627H18.4432Z",
    fill: "#4CB3CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0663 62.7627L17.4648 6.38428H17.845L18.443 62.7627H18.0663Z",
    fill: "#4BB2CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6858 62.7627L17.0879 6.38428H17.4646L18.0661 62.7627H17.6858Z",
    fill: "#49B2CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5755 62.7627L16.9741 6.38428H17.0882L17.6861 62.7627H17.5755Z",
    fill: "#49B2CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4612 62.7627L16.8633 6.38428H16.9739L17.5753 62.7627H17.4612Z",
    fill: "#48B1CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3509 62.7627L16.7495 6.38428H16.8636L17.4615 62.7627H17.3509Z",
    fill: "#48AFCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2366 62.7627L16.6387 6.38428H16.7493L17.3507 62.7627H17.2366Z",
    fill: "#48AFCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1229 62.7627L16.5249 6.38428H16.639L17.2369 62.7627H17.1229Z",
    fill: "#48AECB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.012 62.7627L16.4141 6.38428H16.5247L17.1226 62.7627H17.012Z",
    fill: "#47ADCB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8978 62.7627L16.2998 6.38428H16.4139L17.0118 62.7627H16.8978Z",
    fill: "#47ACCA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7874 62.7627L16.1895 6.38428H16.3001L16.898 62.7627H16.7874Z",
    fill: "#47ACCA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6732 62.7627L16.0752 6.38428H16.1893L16.7872 62.7627H16.6732Z",
    fill: "#46AAC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5628 62.7627L15.9648 6.38428H16.0754L16.6734 62.7627H16.5628Z",
    fill: "#46AAC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4485 62.7627L15.8506 6.38428H15.9646L16.5626 62.7627H16.4485Z",
    fill: "#46A9C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3382 62.7627L15.7402 6.38428H15.8508L16.4488 62.7627H16.3382Z",
    fill: "#45A7C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2239 62.7627L15.626 6.38428H15.74L16.338 62.7627H16.2239Z",
    fill: "#45A7C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1136 62.7627L15.5156 6.38428H15.6262L16.2242 62.7627H16.1136Z",
    fill: "#45A7C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9993 62.7627L15.4014 6.38428H15.5154L16.1134 62.7627H15.9993Z",
    fill: "#45A6C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8885 62.7627L15.2871 6.38428H15.4012L15.9991 62.7627H15.8885Z",
    fill: "#44A4C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7747 62.7627L15.1768 6.38428H15.2874L15.8888 62.7627H15.7747Z",
    fill: "#44A4C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6639 62.7627L15.0625 6.38428H15.1766L15.7745 62.7627H15.6639Z",
    fill: "#44A2C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5501 62.7627L14.9521 6.38428H15.0628L15.6642 62.7627H15.5501Z",
    fill: "#44A2C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4393 62.7627L14.8379 6.38428H14.952L15.5499 62.7627H15.4393Z",
    fill: "#43A1C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3255 62.7627L14.7275 6.38428H14.8381L15.4396 62.7627H15.3255Z",
    fill: "#43A1C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2147 62.7627L14.6133 6.38428H14.7273L15.3253 62.7627H15.2147Z",
    fill: "#439FC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1009 62.7627L14.5029 6.38428H14.6135L15.2149 62.7627H15.1009Z",
    fill: "#439FC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9901 62.7627L14.3887 6.38428H14.5027L15.1007 62.7627H14.9901Z",
    fill: "#429EC4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8758 62.7627L14.2778 6.38428H14.3884L14.9899 62.7627H14.8758Z",
    fill: "#429DC3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7655 62.7627L14.1641 6.38428H14.2781L14.8761 62.7627H14.7655Z",
    fill: "#429DC3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6512 62.7627L14.0532 6.38428H14.1638L14.7652 62.7627H14.6512Z",
    fill: "#419BC3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5409 62.7627L13.9395 6.38428H14.0535L14.6515 62.7627H14.5409Z",
    fill: "#419BC3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4266 62.7627L13.8286 6.38428H13.9392L14.5406 62.7627H14.4266Z",
    fill: "#419AC2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3163 62.7627L13.7148 6.38428H13.8289L14.4269 62.7627H14.3163Z",
    fill: "#4199C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.202 62.7627L13.604 6.38428H13.7146L14.316 62.7627H14.202Z",
    fill: "#4098C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0877 62.7627L13.4897 6.38428H13.6038L14.2018 62.7627H14.0877Z",
    fill: "#4098C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9774 62.7627L13.3794 6.38428H13.49L14.088 62.7627H13.9774Z",
    fill: "#4096C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8631 62.7627L13.2651 6.38428H13.3792L13.9772 62.7627H13.8631Z",
    fill: "#4096C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7527 62.7627L13.1548 6.38428H13.2654L13.8633 62.7627H13.7527Z",
    fill: "#4095C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6385 62.7627L13.0405 6.38428H13.1546L13.7525 62.7627H13.6385Z",
    fill: "#4095C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5281 62.7627L12.9302 6.38428H13.0408L13.6387 62.7627H13.5281Z",
    fill: "#3F93BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4139 62.7627L12.8159 6.38428H12.93L13.5279 62.7627H13.4139Z",
    fill: "#3F93BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3035 62.7627L12.7056 6.38428H12.8162L13.4141 62.7627H13.3035Z",
    fill: "#3F92BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1893 62.7627L12.5913 6.38428H12.7054L13.3033 62.7627H13.1893Z",
    fill: "#3F92BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0784 62.7627L12.4805 6.38428H12.5911L13.189 62.7627H13.0784Z",
    fill: "#3E90BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9647 62.7627L12.3667 6.38428H12.4808L13.0787 62.7627H12.9647Z",
    fill: "#3E90BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8538 62.7627L12.2559 6.38428H12.3665L12.9644 62.7627H12.8538Z",
    fill: "#3E8EBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.74 62.7627L12.1421 6.38428H12.2562L12.8541 62.7627H12.74Z",
    fill: "#3E8EBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6292 62.7627L12.0278 6.38428H12.1419L12.7399 62.7627H12.6292Z",
    fill: "#3D8DBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5154 62.7627L11.9175 6.38428H12.0281L12.6295 62.7627H12.5154Z",
    fill: "#3D8DBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4046 62.7627L11.8032 6.38428H11.9173L12.5152 62.7627H12.4046Z",
    fill: "#3D8CBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2908 62.7627L11.6929 6.38428H11.8035L12.4049 62.7627H12.2908Z",
    fill: "#3D8CBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.18 62.7627L11.5786 6.38428H11.6927L12.2906 62.7627H12.18Z",
    fill: "#3D8BBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0657 62.7627L11.4678 6.38428H11.5784L12.1798 62.7627H12.0657Z",
    fill: "#3D8ABB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9554 62.7627L11.354 6.38428H11.4681L12.066 62.7627H11.9554Z",
    fill: "#3C89BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8411 62.7627L11.2432 6.38428H11.3538L11.9552 62.7627H11.8411Z",
    fill: "#3C89BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7308 62.7627L11.1294 6.38428H11.2435L11.8414 62.7627H11.7308Z",
    fill: "#3C87B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6165 62.7627L11.0186 6.38428H11.1292L11.7306 62.7627H11.6165Z",
    fill: "#3C87B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5062 62.7627L10.9048 6.38428H11.0188L11.6168 62.7627H11.5062Z",
    fill: "#3C86B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3919 62.7627L10.7939 6.38428H10.9046L11.506 62.7627H11.3919Z",
    fill: "#3C86B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2816 62.7627L10.6802 6.38428H10.7942L11.3922 62.7627H11.2816Z",
    fill: "#3B84B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1673 62.7627L10.5693 6.38428H10.6799L11.2814 62.7627H11.1673Z",
    fill: "#3B84B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0565 62.7627L10.4551 6.38428H10.5691L11.1671 62.7627H11.0565Z",
    fill: "#3B83B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9427 62.7627L10.3447 6.38428H10.4553L11.0567 62.7627H10.9427Z",
    fill: "#3B83B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8284 62.7627L10.2305 6.38428H10.3445L10.9425 62.7627H10.8284Z",
    fill: "#3B82B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7181 62.7627L10.1201 6.38428H10.2307L10.8287 62.7627H10.7181Z",
    fill: "#3B82B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6038 62.7627L10.0059 6.38428H10.1199L10.7179 62.7627H10.6038Z",
    fill: "#3A80B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4935 62.7627L9.89551 6.38428H10.0061L10.6041 62.7627H10.4935Z",
    fill: "#3A80B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3792 62.7627L9.78125 6.38428H9.89531L10.4933 62.7627H10.3792Z",
    fill: "#3A80B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2689 62.7627L9.6709 6.38428H9.7815L10.3795 62.7627H10.2689Z",
    fill: "#3A7FB5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1546 62.7627L9.55664 6.38428H9.6707L10.2687 62.7627H10.1546Z",
    fill: "#3A7EB5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0438 62.7627L9.4458 6.38428H9.55641L10.1544 62.7627H10.0438Z",
    fill: "#3A7DB4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.92999 62.7627L9.33203 6.38428H9.44609L10.0441 62.7627H9.92999Z",
    fill: "#3A7DB4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.81915 62.7627L9.22119 6.38428H9.3318L9.92976 62.7627H9.81915Z",
    fill: "#397CB4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.70538 62.7627L9.10742 6.38428H9.22148L9.81944 62.7627H9.70538Z",
    fill: "#397CB4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.59458 62.7627L8.99316 6.38428H9.10723L9.70518 62.7627H9.59458Z",
    fill: "#397AB3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.48077 62.7627L8.88281 6.38428H8.99342L9.59483 62.7627H9.48077Z",
    fill: "#397AB3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.36997 62.7627L8.76855 6.38428H8.88262L9.48058 62.7627H9.36997Z",
    fill: "#3979B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.25567 62.7627L8.65771 6.38428H8.76832L9.36974 62.7627H9.25567Z",
    fill: "#3979B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.14536 62.7627L8.54395 6.38428H8.65801L9.25597 62.7627H9.14536Z",
    fill: "#3878B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.03107 62.7627L8.43311 6.38428H8.54371L9.14513 62.7627H9.03107Z",
    fill: "#3878B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.92075 62.7627L8.31934 6.38428H8.4334L9.03136 62.7627H8.92075Z",
    fill: "#3877B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.80646 62.7627L8.2085 6.38428H8.3191L8.92052 62.7627H8.80646Z",
    fill: "#3876B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.69614 62.7627L8.09473 6.38428H8.20879L8.80675 62.7627H8.69614Z",
    fill: "#3876B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.58185 62.7627L7.98389 6.38428H8.09449L8.69591 62.7627H8.58185Z",
    fill: "#3875B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.47104 62.7627L7.86963 6.38428H7.98369L8.58165 62.7627H8.47104Z",
    fill: "#3875B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.35724 62.7627L7.75928 6.38428H7.86988L8.4713 62.7627H8.35724Z",
    fill: "#3774B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.24644 62.7627L7.64502 6.38428H7.75908L8.35704 62.7627H8.24644Z",
    fill: "#3773B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.13263 62.7627L7.53467 6.38428H7.64527L8.24669 62.7627H8.13263Z",
    fill: "#3773B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.02183 62.7627L7.42041 6.38428H7.53447L8.13243 62.7627H8.02183Z",
    fill: "#3772AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.90802 62.7627L7.31006 6.38428H7.42066L8.02208 62.7627H7.90802Z",
    fill: "#3772AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.79722 62.7627L7.1958 6.38428H7.30986L7.90782 62.7627H7.79722Z",
    fill: "#3771AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.68341 62.7627L7.08545 6.38428H7.19605L7.79747 62.7627H7.68341Z",
    fill: "#3771AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.56915 62.7627L6.97119 6.38428H7.08525L7.68321 62.7627H7.56915Z",
    fill: "#3670AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.45831 62.7627L6.86035 6.38428H6.97096L7.56892 62.7627H7.45831Z",
    fill: "#366FAE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.34454 62.7627L6.74658 6.38428H6.86064L7.4586 62.7627H7.34454Z",
    fill: "#366FAE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.2337 62.7627L6.63574 6.38428H6.74635L7.34431 62.7627H7.2337Z",
    fill: "#366EAD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.11993 62.7627L6.52197 6.38428H6.63603L7.23399 62.7627H7.11993Z",
    fill: "#366EAD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.00909 62.7627L6.41113 6.38428H6.52174L7.1197 62.7627H7.00909Z",
    fill: "#366EAD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.89532 62.7627L6.29736 6.38428H6.41142L7.00938 62.7627H6.89532Z",
    fill: "#366DAD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.78448 62.7627L6.18652 6.38428H6.29713L6.89509 62.7627H6.78448Z",
    fill: "#356BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.67023 62.7627L6.07227 6.38428H6.18633L6.78429 62.7627H6.67023Z",
    fill: "#356BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.55987 62.7627L5.96191 6.38428H6.07252L6.67048 62.7627H6.55987Z",
    fill: "#356BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.44562 62.7627L5.84766 6.38428H5.96172L6.55968 62.7627H6.44562Z",
    fill: "#356AAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.3353 62.7627L5.73389 6.38428H5.84795L6.44591 62.7627H6.3353Z",
    fill: "#356AAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.22101 62.7627L5.62305 6.38428H5.73365L6.33507 62.7627H6.22101Z",
    fill: "#3569AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.11069 62.7627L5.50928 6.38428H5.62334L6.2213 62.7627H6.11069Z",
    fill: "#3569AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.9964 62.7627L5.39844 6.38428H5.50904L6.11046 62.7627H5.9964Z",
    fill: "#3469AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.88608 62.7627L5.28467 6.38428H5.39873L5.99669 62.7627H5.88608Z",
    fill: "#3468AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.77179 62.7627L5.17383 6.38428H5.28443L5.88585 62.7627H5.77179Z",
    fill: "#3468AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.66099 62.7627L5.05957 6.38428H5.17363L5.77159 62.7627H5.66099Z",
    fill: "#3467AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.54718 62.7627L4.94922 6.38428H5.05982L5.66124 62.7627H5.54718Z",
    fill: "#3467AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.43638 62.7627L4.83496 6.38428H4.94902L5.54698 62.7627H5.43638Z",
    fill: "#3466A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.32257 62.7627L4.72461 6.38428H4.83521L5.43663 62.7627H5.32257Z",
    fill: "#3365A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.21177 62.7627L4.61035 6.38428H4.72441L5.32237 62.7627H5.21177Z",
    fill: "#3365A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.09796 62.7627L4.5 6.38428H4.61061L5.21202 62.7627H5.09796Z",
    fill: "#3365A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.98716 62.7627L4.38574 6.38428H4.4998L5.09776 62.7627H4.98716Z",
    fill: "#3364A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.87335 62.7627L4.27539 6.38428H4.386L4.98741 62.7627H4.87335Z",
    fill: "#3364A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.76255 62.7627L4.16113 6.38428H4.27519L4.87315 62.7627H4.76255Z",
    fill: "#3363A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.64825 62.7627L4.05029 6.38428H4.1609L4.76231 62.7627H4.64825Z",
    fill: "#3363A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.53794 62.7627L3.93652 6.38428H4.05059L4.64854 62.7627H4.53794Z",
    fill: "#3362A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.42364 62.7627L3.82568 6.38428H3.93629L4.5377 62.7627H4.42364Z",
    fill: "#3261A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.30987 62.7627L3.71191 6.38428H3.82598L4.42393 62.7627H4.30987Z",
    fill: "#3261A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.19903 62.7627L3.60107 6.38428H3.71168L4.30964 62.7627H4.19903Z",
    fill: "#3261A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.08526 62.7627L3.4873 6.38428H3.60137L4.19933 62.7627H4.08526Z",
    fill: "#3260A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.97442 62.7627L3.37646 6.38428H3.48707L4.08503 62.7627H3.97442Z",
    fill: "#3260A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.86065 62.7627L3.2627 6.38428H3.37676L3.97472 62.7627H3.86065Z",
    fill: "#325FA6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.74981 62.7627L3.15186 6.38428H3.26246L3.86042 62.7627H3.74981Z",
    fill: "#325FA6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.63556 62.7627L3.0376 6.38428H3.15166L3.74962 62.7627H3.63556Z",
    fill: "#325FA6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.52521 62.7627L2.92725 6.38428H3.03785L3.63581 62.7627H3.52521Z",
    fill: "#325DA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.41095 62.7627L2.81299 6.38428H2.92705L3.52501 62.7627H3.41095Z",
    fill: "#325DA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.3006 62.7627L2.70264 6.38428H2.81324L3.4112 62.7627H3.3006Z",
    fill: "#325DA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.18634 62.7627L2.58838 6.38428H2.70244L3.3004 62.7627H3.18634Z",
    fill: "#325DA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.07554 62.7627L2.47412 6.38428H2.58818L3.18614 62.7627H3.07554Z",
    fill: "#325CA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.96173 62.7627L2.36377 6.38428H2.47437L3.07579 62.7627H2.96173Z",
    fill: "#325CA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.85142 62.7627L2.25 6.38428H2.36406L2.96202 62.7627H2.85142Z",
    fill: "#315BA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.73712 62.7627L2.13916 6.38428H2.24977L2.85118 62.7627H2.73712Z",
    fill: "#315BA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.62632 62.7627L2.0249 6.38428H2.13896L2.73692 62.7627H2.62632Z",
    fill: "#315BA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.51251 62.7627L1.91455 6.38428H2.02516L2.62657 62.7627H2.51251Z",
    fill: "#3159A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.40171 62.7627L1.80029 6.38428H1.91435L2.51231 62.7627H2.40171Z",
    fill: "#3159A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.2879 62.7627L1.68994 6.38428H1.80055L2.40196 62.7627H2.2879Z",
    fill: "#3159A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.1771 62.7627L1.57568 6.38428H1.68975L2.2877 62.7627H2.1771Z",
    fill: "#3157A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.06329 62.7627L1.46533 6.38428H1.57594L2.17735 62.7627H2.06329Z",
    fill: "#3157A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.95249 62.7627L1.35107 6.38428H1.46514L2.0631 62.7627H1.95249Z",
    fill: "#3157A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.83868 62.7627L1.24072 6.38428H1.35133L1.95274 62.7627H1.83868Z",
    fill: "#3157A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.72788 62.7627L1.12646 6.38428H1.24053L1.83849 62.7627H1.72788Z",
    fill: "#3156A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.61358 62.7627L1.01562 6.38428H1.12623L1.72765 62.7627H1.61358Z",
    fill: "#3156A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.50327 62.7627L0.901855 6.38428H1.01592L1.61388 62.7627H1.50327Z",
    fill: "#3156A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.38897 62.7627L0.791016 6.38428H0.901621L1.50304 62.7627H1.38897Z",
    fill: "#3155A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.27866 62.7627L0.677246 6.38428H0.791308L1.38927 62.7627H1.27866Z",
    fill: "#3155A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.16437 62.7627L0.566406 6.38428H0.677011L1.27843 62.7627H1.16437Z",
    fill: "#3155A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.05011 62.7627L0.452148 6.38428H0.56621L1.16417 62.7627H1.05011Z",
    fill: "#3155A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.939756 62.7627L0.341797 6.38428H0.452402L1.05036 62.7627H0.939756Z",
    fill: "#3053A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.825498 62.7627L0.227539 6.38428H0.341601L0.93956 62.7627H0.825498Z",
    fill: "#3053A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.715147 62.7627L0.117188 6.38428H0.227793L0.825752 62.7627H0.715147Z",
    fill: "#3053A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.600889 62.7627L0.00292969 6.38428H0.116991L0.714951 62.7627H0.600889Z",
    fill: "#3052A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.490537 62.7627L-0.107422 6.38428H0.00318334L0.601143 62.7627H0.490537Z",
    fill: "#3052A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.37628 62.7627L-0.22168 6.38428H-0.107618L0.490341 62.7627H0.37628Z",
    fill: "#3052A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.265928 62.7627L-0.332031 6.38428H-0.221426L0.376533 62.7627H0.265928Z",
    fill: "#3052A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.15167 62.7627L-0.446289 6.38428H-0.332227L0.265732 62.7627H0.15167Z",
    fill: "#304F9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0408304 62.7627L-0.557129 6.38428H-0.446524L0.151436 62.7627H0.0408304Z",
    fill: "#3051A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.0729392 62.7627L-0.670898 6.38428H-0.556837L0.0411224 62.7627H-0.0729392Z",
    fill: "#3051A0"
  })))))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4453 50.0149L39.3545 27.4495C39.6137 26.2389 40.3949 25.5551 41.5942 25.5551H43.1565C44.3559 25.5551 44.9815 26.2389 44.7188 27.4495L44.1969 30.7115C45.9182 27.0309 49.6166 24.9795 53.8887 24.9795C59.6713 24.9795 63.1657 28.7683 61.759 37.0262L59.4674 50.0184C59.3118 51.229 58.427 51.9128 57.2276 51.9128H55.6653C54.4659 51.9128 53.944 51.229 54.103 50.0184L56.3946 37.0785C57.3313 31.6605 55.2471 29.7137 52.4854 29.7137C49.7237 29.7137 44.0448 31.5558 42.6346 39.5486L40.8131 50.0149C40.6576 51.2255 39.7693 51.9093 38.5733 51.9093H37.011C35.8117 51.9093 35.2898 51.2255 35.4487 50.0149",
    fill: "#304C9D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M64.106 38.809C65.4609 31.1303 72.4429 24.9761 80.6242 24.9761C87.1396 24.9761 92.4521 28.9219 91.7228 37.3368C91.6709 38.5997 90.7861 39.2835 89.5867 39.2835H69.3667C68.3782 44.1748 71.7101 47.7507 77.4443 47.7507C79.9986 47.7507 82.3939 47.0669 84.8445 45.5423C85.9402 44.9109 86.825 44.9632 87.4506 45.804L87.817 46.2261C88.4426 47.1193 88.2871 48.2252 86.8803 49.223C83.4412 51.693 79.7947 52.485 76.5111 52.485C67.3412 52.485 62.8064 46.3308 64.1095 38.809M86.7732 35.2854C86.2513 30.6035 82.7603 29.6057 79.8949 29.6057C76.8706 29.6057 72.913 30.8163 70.5142 35.2854H86.7732Z",
    fill: "#304C9D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3809 50.0149L97.9238 29.7661H94.9547C94.2254 29.7661 93.9143 29.3439 94.0699 28.6601L94.4363 26.6611C94.5399 25.9773 94.9582 25.5586 95.6356 25.5586H98.6565L99.0229 23.6119C100.533 15.1447 105.483 13.3549 109.703 13.3549C113.246 13.3549 115.33 14.7749 116.06 16.8786C116.478 17.9845 116.371 18.5602 115.227 19.0346L113.557 19.6138C112.461 20.0359 112.306 19.9836 111.628 18.9823C111.055 18.0892 110.014 17.981 109.022 17.981C107.197 17.981 105.269 19.1393 104.591 22.9769L104.121 25.5551H118.192L118.559 23.6084C120.069 15.1412 125.019 13.3514 129.239 13.3514C134.085 13.3514 136.273 16.0866 135.702 19.6626C135.547 20.6604 135.284 20.8209 134.399 21.0302L132.626 21.2395C131.793 21.3442 131.219 21.2919 131.219 20.6604C131.323 18.3997 129.864 17.9775 128.561 17.9775C126.736 17.9775 124.808 19.1358 124.134 22.9735L123.664 25.5517H129.343C130.02 25.5517 130.331 25.9738 130.227 26.6541L129.916 28.6532C129.761 29.337 129.343 29.7591 128.613 29.7591H122.986L119.392 50.0079C119.236 51.2185 118.4 51.9023 117.204 51.9023H115.482C114.283 51.9023 113.765 51.2185 113.92 50.0079L117.463 29.7591H103.447L99.9043 50.0079C99.6969 51.2185 98.8639 51.9023 97.6645 51.9023H95.9467C94.7473 51.9023 94.2254 51.2185 94.3844 50.0079",
    fill: "#304C9D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M131.323 61.479L137.212 50.9081L131.219 27.7671C130.856 26.4518 131.637 25.5587 133.044 25.5587H135.128C136.224 25.5587 136.846 26.0332 137.057 27.031L141.173 44.8621L150.969 27.0833C151.543 26.0332 152.324 25.5587 153.42 25.5587H155.607C157.014 25.5587 157.484 26.3995 156.648 27.7671L136.117 62.2187C135.491 63.2723 134.762 63.6909 133.666 63.6909H132.415C131.008 63.6909 130.59 62.7978 131.319 61.4825",
    fill: "#304C9D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M199.241 13.8294C202.328 13.8294 204.989 14.4225 207.226 15.6017C210.845 17.6426 212.39 19.9522 211.857 22.5339C211.643 24.1457 210.634 25.2202 208.823 25.7575C207.226 26.1866 205.895 25.8133 204.83 24.6306C203.341 22.3734 200.945 21.4628 197.645 21.892C197.43 21.892 197.271 21.9478 197.164 22.0524C195.353 22.2687 194.129 23.1793 193.49 24.7911C193.172 25.6494 193.276 26.5634 193.808 27.5298C195.087 28.388 197.161 28.7648 200.036 28.6567C201.74 28.6567 203.016 28.7648 203.87 28.9776C207.274 29.2986 210.043 31.0186 212.172 34.134C213.554 36.0668 214.194 38.1636 214.087 40.4208C214.194 43.8607 212.808 46.7076 209.936 48.9648C208.764 49.823 207.54 50.4684 206.261 50.8976C200.617 52.7222 195.616 52.7222 191.25 50.8976C187.739 49.1776 185.661 47.1367 185.022 44.7713C184.597 42.9467 185.288 41.4953 187.099 40.4208C188.803 39.3463 190.345 39.4021 191.731 40.5813C191.942 40.6894 192.104 40.7976 192.211 40.9022C194.019 43.2676 197.213 44.0735 201.792 43.32C203.6 43.2118 204.827 42.5141 205.463 41.2232C205.888 40.4731 205.888 39.6672 205.463 38.8055C204.506 37.731 202.802 37.1937 200.354 37.1937C195.032 37.41 191.147 36.3355 188.696 33.9701C186.035 31.7128 184.811 28.7579 185.022 25.1051C185.022 22.7432 185.713 20.6465 187.099 18.8184C189.546 15.3819 193.487 13.7143 198.917 13.8224H199.235L199.241 13.8294Z",
    fill: "#00AEEF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M226.519 24.5191C228.922 24.5191 231.092 25.1436 233.028 26.396C234.034 27.1007 234.538 28.0392 234.538 29.2115C234.383 30.4639 233.764 31.364 232.679 31.9083C231.593 32.3793 230.588 32.2606 229.658 31.5559C228.804 31.0849 227.76 30.8512 226.519 30.8512C225.51 30.8512 224.542 31.1268 223.613 31.671C221.909 32.8433 221.055 35.0726 221.055 38.359V38.4776C221.055 41.9978 221.867 44.3073 223.495 45.3993C224.345 45.9471 225.355 46.2192 226.516 46.2192C227.757 46.2192 228.801 45.9471 229.654 45.3993C230.584 44.6178 231.59 44.4992 232.675 45.047C233.761 45.5947 234.379 46.4948 234.535 47.7438C234.535 48.9962 234.03 49.8963 233.024 50.4441C231.085 51.7733 228.918 52.4397 226.516 52.4397C224.114 52.4397 222.019 51.8152 220.239 50.5627C216.672 48.295 214.892 44.2271 214.892 38.359C214.892 33.3526 216.403 29.5987 219.427 27.0938C221.362 25.3738 223.727 24.5121 226.516 24.5121L226.519 24.5191Z",
    fill: "#00AEEF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M235.479 49.3765V16.9903C235.479 15.7378 236.021 14.761 237.107 14.0563C237.573 13.8993 238.036 13.8225 238.503 13.8225C239.433 13.8225 240.169 14.0981 240.712 14.6424C241.33 15.2669 241.641 16.0518 241.641 16.9903V25.9076C243.269 25.1261 244.897 24.7354 246.522 24.7354C250.32 24.7354 253.224 26.1065 255.239 28.8416C256.943 30.9523 257.759 33.3003 257.679 35.882V49.3765C257.755 50.629 257.25 51.5675 256.169 52.192C255.083 52.7397 254.078 52.7397 253.148 52.192C252.062 51.5675 251.52 50.629 251.52 49.3765V35.882C251.209 33.2235 250.279 31.6571 248.73 31.1896C248.188 30.9558 247.452 30.8372 246.522 30.8372C244.583 30.8372 243.304 31.4617 242.685 32.7142C242.066 33.9666 241.717 35.0237 241.638 35.882V49.3765C241.638 50.9395 240.902 51.9582 239.429 52.4257C238.188 52.7397 237.103 52.4257 236.173 51.4872C235.71 50.9395 235.475 50.2348 235.475 49.3765H235.479Z",
    fill: "#00AEEF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M276.465 26.6472C279.952 29.3056 281.694 33.2968 281.694 38.6136C281.694 44.3247 279.952 48.3508 276.465 50.6987C274.526 51.9512 272.359 52.5757 269.956 52.5757C267.243 52.5757 264.841 51.7942 262.75 50.2277C259.805 47.7263 258.37 43.8538 258.45 38.6136C258.45 33.0595 260.192 29.1102 263.679 26.7623C265.539 25.4331 267.63 24.7667 269.956 24.7667C272.435 24.7667 274.605 25.3912 276.465 26.6437V26.6472ZM269.956 46.4738C273.755 46.4738 275.652 43.8538 275.652 38.6136C275.652 33.3735 273.755 30.9872 269.956 30.9872C268.947 30.9872 267.979 31.3012 267.049 31.9257C265.345 33.0211 264.492 35.2505 264.492 38.6136V39.0846C264.492 44.0108 266.313 46.4773 269.956 46.4773V46.4738Z",
    fill: "#00AEEF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M312.826 49.4812C312.826 49.8719 312.746 50.2627 312.594 50.6534C312.052 51.8257 311.122 52.4118 309.805 52.4118C309.338 52.4118 308.913 52.335 308.526 52.178C307.365 51.6303 306.784 50.7302 306.784 49.4777V17.3322C306.784 16.7845 306.86 16.317 307.016 15.9228C307.634 14.7505 308.564 14.1644 309.805 14.1644C310.268 14.1644 310.655 14.2447 310.966 14.3982C312.207 14.9459 312.826 15.9228 312.826 17.3322V49.4812Z",
    fill: "#00AEEF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M324.181 24.4319C326.427 24.4319 328.366 24.861 329.994 25.7227C332.628 27.2089 333.751 28.8905 333.364 30.7675C333.209 31.9397 332.473 32.7247 331.156 33.1154C329.994 33.4294 329.023 33.1538 328.249 32.2956C327.163 30.6524 325.421 29.9895 323.019 30.3C322.864 30.3 322.746 30.3384 322.67 30.4186C321.353 30.5756 320.461 31.2385 319.995 32.4142C319.763 33.0387 319.839 33.705 320.226 34.4098C321.156 35.0342 322.667 35.3099 324.761 35.2296C326.002 35.2296 326.932 35.3099 327.551 35.4634C330.029 35.6971 332.044 36.9496 333.596 39.2173C334.602 40.6267 335.068 42.1513 334.992 43.7945C335.068 46.2995 334.062 48.3718 331.971 50.0115C331.118 50.636 330.229 51.107 329.3 51.421C325.193 52.7502 321.55 52.7502 318.374 51.421C315.816 50.1685 314.306 48.6823 313.839 46.9623C313.528 45.6331 314.033 44.576 315.349 43.7945C316.59 43.0131 317.714 43.0514 318.719 43.9132C318.875 43.9934 318.989 44.0702 319.069 44.1469C320.385 45.8669 322.712 46.4565 326.044 45.9052C327.36 45.8285 328.252 45.3191 328.719 44.3807C329.03 43.8329 329.03 43.2468 328.719 42.6223C328.021 41.8408 326.78 41.4501 325 41.4501C321.125 41.6071 318.294 40.8256 316.514 39.1021C314.575 37.4589 313.687 35.3099 313.839 32.6479C313.839 30.928 314.344 29.4034 315.349 28.0707C317.133 25.5692 319.998 24.3551 323.952 24.4319H324.184H324.181Z",
    fill: "#00AEEF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M206.32 16.5472L202.318 9.18243L211.505 0L187.714 5.44596L171.518 22.1467C171.618 22.3944 171.597 22.2827 171.742 22.2548C173.063 21.9827 174.369 21.6199 175.7 21.4036L177.794 25.2936C177.677 25.6494 177.376 25.8518 177.276 26.2425C176.965 27.4496 178.002 28.6253 179.201 28.4614L181.047 35.9727C181.147 36.2483 181.572 35.861 181.641 35.711C181.832 35.2993 181.593 34.0748 181.883 33.6073L182.924 35.1074L185.07 33.9178L180.224 27.8473C181.341 26.4379 180 24.6795 178.334 25.011L176.357 21.3722L176.481 21.1768L182.948 19.7429L187.096 27.3729C187.341 26.9263 187.503 26.4309 187.759 25.9878C188.371 24.9447 189.218 23.9539 190.199 23.0293C189.024 19.6906 190.87 15.0401 195.498 15.0401C197.537 15.0401 198.961 15.9402 199.798 17.231C201.903 16.467 204.17 16.0553 206.358 16.7007C206.635 16.5786 206.348 16.5821 206.327 16.5437L206.32 16.5472Z",
    fill: "#00AEEF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M300.518 26.5949C304.005 29.2534 305.748 33.2445 305.748 38.5614C305.748 44.2725 304.005 48.2985 300.518 50.6465C298.579 51.8989 296.412 52.5234 294.01 52.5234C291.296 52.5234 288.894 51.7419 286.803 50.1755C283.858 47.674 282.424 43.8015 282.503 38.5614C282.503 33.0073 284.245 29.058 287.733 26.7101C289.592 25.3808 291.683 24.7145 294.01 24.7145C296.488 24.7145 298.658 25.339 300.518 26.5914V26.5949ZM294.01 46.4216C297.808 46.4216 299.706 43.8015 299.706 38.5614C299.706 33.3213 297.808 30.9349 294.01 30.9349C293 30.9349 292.032 31.2489 291.103 31.8734C289.399 32.9689 288.545 35.1982 288.545 38.5614V39.0324C288.545 43.9585 290.366 46.4251 294.01 46.4251V46.4216Z",
    fill: "#00AEEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeffyInSchools);
export default __webpack_public_path__ + "static/media/neffy-in-schools.d531e91bdf97a1d0b23e035b455740c9.svg";
export { ForwardRef as ReactComponent };